import { createEvent } from 'effector';
import { type AppealProps } from './Appeal';
import { openAppealModal } from './lib';

export const appeal = createEvent<AppealProps>();

appeal.watch(openAppealModal);
